import { render } from "./EssentialFactsPage.vue?vue&type=template&id=de7830e2"
import script from "./EssentialFactsPage.vue?vue&type=script&lang=js"
export * from "./EssentialFactsPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\PR024\\Desktop\\uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__